import React, { CSSProperties, forwardRef } from "react";
import TableDemo from '../components/TableDemo';




interface ContentTemplateProps {
  //metadata?: React.ReactNode[],
  //genericasSistema?: React.ReactNode[],
  //selectedTipoGenerica?: React.ReactNode,
  contenido: string,
  tipoContenido?: 'portadaReporte' | 'portadaReporte' | 'cabeceraReporte' | 'cuerpoReporte' |
  'piePaginaReporte' | 'resumenReporte',
}

const ContentTemplate = React.forwardRef((props?: ContentTemplateProps, ref?: React.Ref<HTMLDivElement>) => {

  const styles = {
    coverBg: {
      position: "absolute",
      left: 0,
      top: 0,
      zIndex: 0,
      width: "596px",
      height: "100%"
    } as CSSProperties,
    container: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      position: "relative",
      overflow: "hidden",
      width: "446px",
      height: "631px"
    } as CSSProperties,
    contentContainer: {
      width: "446px",
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    } as CSSProperties,
    contentCard: {
      zIndex: 1,
      backgroundColor: "black"
    } as CSSProperties,
    title: {
      fontFamily: "Anton, Anton-Regular",
      fontSize: "1rem",
      color: "white",
      textAlign: "center"
    } as CSSProperties,
    imgContainer: {
      width: "300px"
    } as CSSProperties,
    img: {
      display: "block",
      width: "100%",
      height: "100%"
    } as CSSProperties
  };

  //let tgViewReport = props?.selectedTipoGenerica?.operaciones.find(x => x.tipoOperacion === "VIEW" && x.seccion === "REPORT");

  //let gsViewReport = props?.genericasSistema?.find(x => x.tg === tgViewReport.tgRef);

  //let structReport = gsViewReport.uts;



  /*
  const genericaSistemaService = new GenericaSistemaService();
  let  fileBase64 = genericaSistemaService.GetFileBase64(2, "ES", "userName","/assets/logos/logo-menu.png");
console.log("fileBase64, ", fileBase64);

  */

  //return (<><TableDemo></TableDemo></>);



  return (<>
    {
      (function () {
        //rounded text raised                         
        if (props?.contenido !== null && props?.contenido !== "")
          return (<div ref={ref} dangerouslySetInnerHTML={{ __html: props?.contenido }} />);
        else
          return (<></>);
      })()
    }
    </>
  );

  return (<>

    {
      (function () {
        //rounded text raised                         
        if (props?.contenido !== null && props?.contenido !== "")
          return (<div ref={ref} dangerouslySetInnerHTML={{ __html: props?.contenido }} />);
        else
          return (<></>);
      })()
    }


  </>);

return (
  <div style={styles.container}>
    <img
      alt="cover"
      style={styles.coverBg}
      src={"../assets/layout/images/cover_bg.jpg"}
    />
    <div style={styles.contentContainer}>
      <div style={styles.contentCard}>
        <p style={styles.title}>Drivers putting $50 in their car today</p>
        <div style={styles.imgContainer}>
        <img
            alt="meme"
            src="https://comunicaciones.cecar.edu.co/media/k2/items/cache/e03671e065714a25f5029ba8f4393eb5_M.jpg"
          />
        </div>
      </div>
    </div>
  </div>
);



});

export default ContentTemplate;
